/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ITargetArea {
  Back = 'Back',
  Chest = 'Chest',
  Arms = 'Arms',
  Shoulders = 'Shoulders',
  Glutes = 'Glutes',
  Legs = 'Legs',
  Core = 'Core',
  TotalBody = 'Total Body',
  UpperBody = 'Upper Body',
  Abs = 'Abs',
}
